import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/recursos_humanos/puesto';
import Puesto from './PuestoList';


const ms2p = (state) => {
  return {
    ...state.puesto,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Puesto);
